(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[32465,66311,29608],{

/***/ 19642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ul": function() { return /* binding */ _createForOfIteratorHelperLoose; },
/* harmony export */   "gK": function() { return /* binding */ _objectWithoutPropertiesLoose; },
/* harmony export */   "gY": function() { return /* binding */ _extends; }
/* harmony export */ });
/* unused harmony exports arrayLikeToArray, unsupportedIterableToArray */
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}


//# sourceMappingURL=_rollupPluginBabelHelpers.js.map


/***/ }),

/***/ 62659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ Keys; }
/* harmony export */ });
// TODO: This must already exist somewhere, right? 🤔
// Ref: https://www.w3.org/TR/uievents-key/#named-key-attribute-values
var Keys;

(function (Keys) {
  Keys["Space"] = " ";
  Keys["Enter"] = "Enter";
  Keys["Escape"] = "Escape";
  Keys["Backspace"] = "Backspace";
  Keys["ArrowLeft"] = "ArrowLeft";
  Keys["ArrowUp"] = "ArrowUp";
  Keys["ArrowRight"] = "ArrowRight";
  Keys["ArrowDown"] = "ArrowDown";
  Keys["Home"] = "Home";
  Keys["End"] = "End";
  Keys["PageUp"] = "PageUp";
  Keys["PageDown"] = "PageDown";
  Keys["Tab"] = "Tab";
})(Keys || (Keys = {}));


//# sourceMappingURL=keyboard.esm.js.map


/***/ }),

/***/ 66311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Tab; }
/* harmony export */ });
/* harmony import */ var _virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19642);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_match_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(133);
/* harmony import */ var _utils_render_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58529);
/* harmony import */ var _hooks_use_sync_refs_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57471);
/* harmony import */ var _keyboard_esm_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62659);
/* harmony import */ var _hooks_use_iso_morphic_effect_esm_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60852);
/* harmony import */ var _hooks_use_id_esm_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92506);
/* harmony import */ var _utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35057);
/* harmony import */ var _hooks_use_resolve_button_type_esm_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56637);











var _reducers;
var ActionTypes;

(function (ActionTypes) {
  ActionTypes[ActionTypes["SetSelectedIndex"] = 0] = "SetSelectedIndex";
  ActionTypes[ActionTypes["SetOrientation"] = 1] = "SetOrientation";
  ActionTypes[ActionTypes["SetActivation"] = 2] = "SetActivation";
  ActionTypes[ActionTypes["RegisterTab"] = 3] = "RegisterTab";
  ActionTypes[ActionTypes["UnregisterTab"] = 4] = "UnregisterTab";
  ActionTypes[ActionTypes["RegisterPanel"] = 5] = "RegisterPanel";
  ActionTypes[ActionTypes["UnregisterPanel"] = 6] = "UnregisterPanel";
  ActionTypes[ActionTypes["ForceRerender"] = 7] = "ForceRerender";
})(ActionTypes || (ActionTypes = {}));

var reducers = (_reducers = {}, _reducers[ActionTypes.SetSelectedIndex] = function (state, action) {
  if (state.selectedIndex === action.index) return state;
  return (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* ["extends"] */ .gY)({}, state, {
    selectedIndex: action.index
  });
}, _reducers[ActionTypes.SetOrientation] = function (state, action) {
  if (state.orientation === action.orientation) return state;
  return (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* ["extends"] */ .gY)({}, state, {
    orientation: action.orientation
  });
}, _reducers[ActionTypes.SetActivation] = function (state, action) {
  if (state.activation === action.activation) return state;
  return (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* ["extends"] */ .gY)({}, state, {
    activation: action.activation
  });
}, _reducers[ActionTypes.RegisterTab] = function (state, action) {
  if (state.tabs.includes(action.tab)) return state;
  return (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* ["extends"] */ .gY)({}, state, {
    tabs: [].concat(state.tabs, [action.tab])
  });
}, _reducers[ActionTypes.UnregisterTab] = function (state, action) {
  return (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* ["extends"] */ .gY)({}, state, {
    tabs: state.tabs.filter(function (tab) {
      return tab !== action.tab;
    })
  });
}, _reducers[ActionTypes.RegisterPanel] = function (state, action) {
  if (state.panels.includes(action.panel)) return state;
  return (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* ["extends"] */ .gY)({}, state, {
    panels: [].concat(state.panels, [action.panel])
  });
}, _reducers[ActionTypes.UnregisterPanel] = function (state, action) {
  return (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* ["extends"] */ .gY)({}, state, {
    panels: state.panels.filter(function (panel) {
      return panel !== action.panel;
    })
  });
}, _reducers[ActionTypes.ForceRerender] = function (state) {
  return (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* ["extends"] */ .gY)({}, state);
}, _reducers);
var TabsContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
TabsContext.displayName = 'TabsContext';

function useTabsContext(component) {
  var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(TabsContext);

  if (context === null) {
    var err = new Error("<" + component + " /> is missing a parent <Tab.Group /> component.");
    if (Error.captureStackTrace) Error.captureStackTrace(err, useTabsContext);
    throw err;
  }

  return context;
}

function stateReducer(state, action) {
  return (0,_utils_match_esm_js__WEBPACK_IMPORTED_MODULE_2__/* .match */ .E)(action.type, reducers, state, action);
} // ---


var DEFAULT_TABS_TAG = react__WEBPACK_IMPORTED_MODULE_0__.Fragment;

function Tabs(props) {
  var _props$defaultIndex = props.defaultIndex,
      defaultIndex = _props$defaultIndex === void 0 ? 0 : _props$defaultIndex,
      _props$vertical = props.vertical,
      vertical = _props$vertical === void 0 ? false : _props$vertical,
      _props$manual = props.manual,
      manual = _props$manual === void 0 ? false : _props$manual,
      onChange = props.onChange,
      _props$selectedIndex = props.selectedIndex,
      selectedIndex = _props$selectedIndex === void 0 ? null : _props$selectedIndex,
      passThroughProps = (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* .objectWithoutPropertiesLoose */ .gK)(props, ["defaultIndex", "vertical", "manual", "onChange", "selectedIndex"]);

  var orientation = vertical ? 'vertical' : 'horizontal';
  var activation = manual ? 'manual' : 'auto';

  var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(stateReducer, {
    selectedIndex: null,
    tabs: [],
    panels: [],
    orientation: orientation,
    activation: activation
  }),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var slot = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      selectedIndex: state.selectedIndex
    };
  }, [state.selectedIndex]);
  var onChangeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () {});
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    dispatch({
      type: ActionTypes.SetOrientation,
      orientation: orientation
    });
  }, [orientation]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    dispatch({
      type: ActionTypes.SetActivation,
      activation: activation
    });
  }, [activation]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (typeof onChange === 'function') {
      onChangeRef.current = onChange;
    }
  }, [onChange]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (state.tabs.length <= 0) return;
    if (selectedIndex === null && state.selectedIndex !== null) return;
    var tabs = state.tabs.map(function (tab) {
      return tab.current;
    }).filter(Boolean);
    var focusableTabs = tabs.filter(function (tab) {
      return !tab.hasAttribute('disabled');
    });
    var indexToSet = selectedIndex != null ? selectedIndex : defaultIndex; // Underflow

    if (indexToSet < 0) {
      dispatch({
        type: ActionTypes.SetSelectedIndex,
        index: tabs.indexOf(focusableTabs[0])
      });
    } // Overflow
    else if (indexToSet > state.tabs.length) {
        dispatch({
          type: ActionTypes.SetSelectedIndex,
          index: tabs.indexOf(focusableTabs[focusableTabs.length - 1])
        });
      } // Middle
      else {
          var before = tabs.slice(0, indexToSet);
          var after = tabs.slice(indexToSet);
          var next = [].concat(after, before).find(function (tab) {
            return focusableTabs.includes(tab);
          });
          if (!next) return;
          dispatch({
            type: ActionTypes.SetSelectedIndex,
            index: tabs.indexOf(next)
          });
        }
  }, [defaultIndex, selectedIndex, state.tabs, state.selectedIndex]);
  var lastChangedIndex = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(state.selectedIndex);
  var providerBag = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return [state, {
      dispatch: dispatch,
      change: function change(index) {
        if (lastChangedIndex.current !== index) onChangeRef.current(index);
        lastChangedIndex.current = index;
        dispatch({
          type: ActionTypes.SetSelectedIndex,
          index: index
        });
      }
    }];
  }, [state, dispatch]);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(TabsContext.Provider, {
    value: providerBag
  }, (0,_utils_render_esm_js__WEBPACK_IMPORTED_MODULE_3__/* .render */ .sY)({
    props: (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* ["extends"] */ .gY)({}, passThroughProps),
    slot: slot,
    defaultTag: DEFAULT_TABS_TAG,
    name: 'Tabs'
  }));
} // ---


var DEFAULT_LIST_TAG = 'div';

function List(props) {
  var _useTabsContext = useTabsContext([Tab.name, List.name].join('.')),
      _useTabsContext$ = _useTabsContext[0],
      selectedIndex = _useTabsContext$.selectedIndex,
      orientation = _useTabsContext$.orientation;

  var slot = {
    selectedIndex: selectedIndex
  };
  var propsWeControl = {
    role: 'tablist',
    'aria-orientation': orientation
  };
  var passThroughProps = props;
  return (0,_utils_render_esm_js__WEBPACK_IMPORTED_MODULE_3__/* .render */ .sY)({
    props: (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* ["extends"] */ .gY)({}, passThroughProps, propsWeControl),
    slot: slot,
    defaultTag: DEFAULT_LIST_TAG,
    name: 'Tabs.List'
  });
} // ---


var DEFAULT_TAB_TAG = 'button';
function Tab(props) {
  var _panels$myIndex, _panels$myIndex$curre;

  var id = "headlessui-tabs-tab-" + (0,_hooks_use_id_esm_js__WEBPACK_IMPORTED_MODULE_4__/* .useId */ .M)();

  var _useTabsContext2 = useTabsContext(Tab.name),
      _useTabsContext2$ = _useTabsContext2[0],
      selectedIndex = _useTabsContext2$.selectedIndex,
      tabs = _useTabsContext2$.tabs,
      panels = _useTabsContext2$.panels,
      orientation = _useTabsContext2$.orientation,
      activation = _useTabsContext2$.activation,
      _useTabsContext2$2 = _useTabsContext2[1],
      dispatch = _useTabsContext2$2.dispatch,
      change = _useTabsContext2$2.change;

  var internalTabRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var tabRef = (0,_hooks_use_sync_refs_esm_js__WEBPACK_IMPORTED_MODULE_5__/* .useSyncRefs */ .T)(internalTabRef, function (element) {
    if (!element) return;
    dispatch({
      type: ActionTypes.ForceRerender
    });
  });
  (0,_hooks_use_iso_morphic_effect_esm_js__WEBPACK_IMPORTED_MODULE_6__/* .useIsoMorphicEffect */ .e)(function () {
    dispatch({
      type: ActionTypes.RegisterTab,
      tab: internalTabRef
    });
    return function () {
      return dispatch({
        type: ActionTypes.UnregisterTab,
        tab: internalTabRef
      });
    };
  }, [dispatch, internalTabRef]);
  var myIndex = tabs.indexOf(internalTabRef);
  var selected = myIndex === selectedIndex;
  var handleKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (event) {
    var list = tabs.map(function (tab) {
      return tab.current;
    }).filter(Boolean);

    if (event.key === _keyboard_esm_js__WEBPACK_IMPORTED_MODULE_7__/* .Keys.Space */ .R.Space || event.key === _keyboard_esm_js__WEBPACK_IMPORTED_MODULE_7__/* .Keys.Enter */ .R.Enter) {
      event.preventDefault();
      event.stopPropagation();
      change(myIndex);
      return;
    }

    switch (event.key) {
      case _keyboard_esm_js__WEBPACK_IMPORTED_MODULE_7__/* .Keys.Home */ .R.Home:
      case _keyboard_esm_js__WEBPACK_IMPORTED_MODULE_7__/* .Keys.PageUp */ .R.PageUp:
        event.preventDefault();
        event.stopPropagation();
        return (0,_utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .focusIn */ .jA)(list, _utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .Focus.First */ .TO.First);

      case _keyboard_esm_js__WEBPACK_IMPORTED_MODULE_7__/* .Keys.End */ .R.End:
      case _keyboard_esm_js__WEBPACK_IMPORTED_MODULE_7__/* .Keys.PageDown */ .R.PageDown:
        event.preventDefault();
        event.stopPropagation();
        return (0,_utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .focusIn */ .jA)(list, _utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .Focus.Last */ .TO.Last);
    }

    return (0,_utils_match_esm_js__WEBPACK_IMPORTED_MODULE_2__/* .match */ .E)(orientation, {
      vertical: function vertical() {
        if (event.key === _keyboard_esm_js__WEBPACK_IMPORTED_MODULE_7__/* .Keys.ArrowUp */ .R.ArrowUp) return (0,_utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .focusIn */ .jA)(list, _utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .Focus.Previous */ .TO.Previous | _utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .Focus.WrapAround */ .TO.WrapAround);
        if (event.key === _keyboard_esm_js__WEBPACK_IMPORTED_MODULE_7__/* .Keys.ArrowDown */ .R.ArrowDown) return (0,_utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .focusIn */ .jA)(list, _utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .Focus.Next */ .TO.Next | _utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .Focus.WrapAround */ .TO.WrapAround);
        return;
      },
      horizontal: function horizontal() {
        if (event.key === _keyboard_esm_js__WEBPACK_IMPORTED_MODULE_7__/* .Keys.ArrowLeft */ .R.ArrowLeft) return (0,_utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .focusIn */ .jA)(list, _utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .Focus.Previous */ .TO.Previous | _utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .Focus.WrapAround */ .TO.WrapAround);
        if (event.key === _keyboard_esm_js__WEBPACK_IMPORTED_MODULE_7__/* .Keys.ArrowRight */ .R.ArrowRight) return (0,_utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .focusIn */ .jA)(list, _utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .Focus.Next */ .TO.Next | _utils_focus_management_esm_js__WEBPACK_IMPORTED_MODULE_8__/* .Focus.WrapAround */ .TO.WrapAround);
        return;
      }
    });
  }, [tabs, orientation, myIndex, change]);
  var handleFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var _internalTabRef$curre;

    (_internalTabRef$curre = internalTabRef.current) == null ? void 0 : _internalTabRef$curre.focus();
  }, [internalTabRef]);
  var handleSelection = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var _internalTabRef$curre2;

    (_internalTabRef$curre2 = internalTabRef.current) == null ? void 0 : _internalTabRef$curre2.focus();
    change(myIndex);
  }, [change, myIndex, internalTabRef]);
  var slot = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      selected: selected
    };
  }, [selected]);
  var propsWeControl = {
    ref: tabRef,
    onKeyDown: handleKeyDown,
    onFocus: activation === 'manual' ? handleFocus : handleSelection,
    onClick: handleSelection,
    id: id,
    role: 'tab',
    type: (0,_hooks_use_resolve_button_type_esm_js__WEBPACK_IMPORTED_MODULE_9__/* .useResolveButtonType */ .f)(props, internalTabRef),
    'aria-controls': (_panels$myIndex = panels[myIndex]) == null ? void 0 : (_panels$myIndex$curre = _panels$myIndex.current) == null ? void 0 : _panels$myIndex$curre.id,
    'aria-selected': selected,
    tabIndex: selected ? 0 : -1
  };
  var passThroughProps = props;

  if (false) {}

  return (0,_utils_render_esm_js__WEBPACK_IMPORTED_MODULE_3__/* .render */ .sY)({
    props: (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* ["extends"] */ .gY)({}, passThroughProps, propsWeControl),
    slot: slot,
    defaultTag: DEFAULT_TAB_TAG,
    name: 'Tabs.Tab'
  });
} // ---

var DEFAULT_PANELS_TAG = 'div';

function Panels(props) {
  var _useTabsContext3 = useTabsContext([Tab.name, Panels.name].join('.')),
      selectedIndex = _useTabsContext3[0].selectedIndex;

  var slot = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      selectedIndex: selectedIndex
    };
  }, [selectedIndex]);
  return (0,_utils_render_esm_js__WEBPACK_IMPORTED_MODULE_3__/* .render */ .sY)({
    props: props,
    slot: slot,
    defaultTag: DEFAULT_PANELS_TAG,
    name: 'Tabs.Panels'
  });
} // ---


var DEFAULT_PANEL_TAG = 'div';
var PanelRenderFeatures = _utils_render_esm_js__WEBPACK_IMPORTED_MODULE_3__/* .Features.RenderStrategy */ .AN.RenderStrategy | _utils_render_esm_js__WEBPACK_IMPORTED_MODULE_3__/* .Features.Static */ .AN.Static;

function Panel(props) {
  var _tabs$myIndex, _tabs$myIndex$current;

  var _useTabsContext4 = useTabsContext([Tab.name, Panel.name].join('.')),
      _useTabsContext4$ = _useTabsContext4[0],
      selectedIndex = _useTabsContext4$.selectedIndex,
      tabs = _useTabsContext4$.tabs,
      panels = _useTabsContext4$.panels,
      dispatch = _useTabsContext4[1].dispatch;

  var id = "headlessui-tabs-panel-" + (0,_hooks_use_id_esm_js__WEBPACK_IMPORTED_MODULE_4__/* .useId */ .M)();
  var internalPanelRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var panelRef = (0,_hooks_use_sync_refs_esm_js__WEBPACK_IMPORTED_MODULE_5__/* .useSyncRefs */ .T)(internalPanelRef, function (element) {
    if (!element) return;
    dispatch({
      type: ActionTypes.ForceRerender
    });
  });
  (0,_hooks_use_iso_morphic_effect_esm_js__WEBPACK_IMPORTED_MODULE_6__/* .useIsoMorphicEffect */ .e)(function () {
    dispatch({
      type: ActionTypes.RegisterPanel,
      panel: internalPanelRef
    });
    return function () {
      return dispatch({
        type: ActionTypes.UnregisterPanel,
        panel: internalPanelRef
      });
    };
  }, [dispatch, internalPanelRef]);
  var myIndex = panels.indexOf(internalPanelRef);
  var selected = myIndex === selectedIndex;
  var slot = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      selected: selected
    };
  }, [selected]);
  var propsWeControl = {
    ref: panelRef,
    id: id,
    role: 'tabpanel',
    'aria-labelledby': (_tabs$myIndex = tabs[myIndex]) == null ? void 0 : (_tabs$myIndex$current = _tabs$myIndex.current) == null ? void 0 : _tabs$myIndex$current.id,
    tabIndex: selected ? 0 : -1
  };

  if (false) {}

  var passThroughProps = props;
  return (0,_utils_render_esm_js__WEBPACK_IMPORTED_MODULE_3__/* .render */ .sY)({
    props: (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* ["extends"] */ .gY)({}, passThroughProps, propsWeControl),
    slot: slot,
    defaultTag: DEFAULT_PANEL_TAG,
    features: PanelRenderFeatures,
    visible: selected,
    name: 'Tabs.Panel'
  });
} // ---


Tab.Group = Tabs;
Tab.List = List;
Tab.Panels = Panels;
Tab.Panel = Panel;


//# sourceMappingURL=tabs.esm.js.map


/***/ }),

/***/ 92506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_iso_morphic_effect_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60852);
/* harmony import */ var _use_server_handoff_complete_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35989);




// didn't take care of the Suspense case. To fix this we used the approach the @reach-ui/auto-id
// uses.
//
// Credits: https://github.com/reach/reach-ui/blob/develop/packages/auto-id/src/index.tsx

var id = 0;

function generateId() {
  return ++id;
}

function useId() {
  var ready = (0,_use_server_handoff_complete_esm_js__WEBPACK_IMPORTED_MODULE_1__/* .useServerHandoffComplete */ .H)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(ready ? generateId : null),
      id = _useState[0],
      setId = _useState[1];

  (0,_use_iso_morphic_effect_esm_js__WEBPACK_IMPORTED_MODULE_2__/* .useIsoMorphicEffect */ .e)(function () {
    if (id === null) setId(generateId());
  }, [id]);
  return id != null ? '' + id : undefined;
}


//# sourceMappingURL=use-id.esm.js.map


/***/ }),

/***/ 60852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useIsoMorphicEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useIsoMorphicEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;


//# sourceMappingURL=use-iso-morphic-effect.esm.js.map


/***/ }),

/***/ 56637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useResolveButtonType; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_iso_morphic_effect_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60852);



function resolveType(props) {
  var _props$as;

  if (props.type) return props.type;
  var tag = (_props$as = props.as) != null ? _props$as : 'button';
  if (typeof tag === 'string' && tag.toLowerCase() === 'button') return 'button';
  return undefined;
}

function useResolveButtonType(props, ref) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
    return resolveType(props);
  }),
      type = _useState[0],
      setType = _useState[1];

  (0,_use_iso_morphic_effect_esm_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsoMorphicEffect */ .e)(function () {
    setType(resolveType(props));
  }, [props.type, props.as]);
  (0,_use_iso_morphic_effect_esm_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsoMorphicEffect */ .e)(function () {
    if (type) return;
    if (!ref.current) return;

    if (ref.current instanceof HTMLButtonElement && !ref.current.hasAttribute('type')) {
      setType('button');
    }
  }, [type, ref]);
  return type;
}


//# sourceMappingURL=use-resolve-button-type.esm.js.map


/***/ }),

/***/ 35989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useServerHandoffComplete; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var state = {
  serverHandoffComplete: false
};
function useServerHandoffComplete() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(state.serverHandoffComplete),
      serverHandoffComplete = _useState[0],
      setServerHandoffComplete = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (serverHandoffComplete === true) return;
    setServerHandoffComplete(true);
  }, [serverHandoffComplete]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (state.serverHandoffComplete === false) state.serverHandoffComplete = true;
  }, []);
  return serverHandoffComplete;
}


//# sourceMappingURL=use-server-handoff-complete.esm.js.map


/***/ }),

/***/ 57471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useSyncRefs; }
/* harmony export */ });
/* harmony import */ var _virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19642);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



function useSyncRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  var cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(refs);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    cache.current = refs;
  }, [refs]);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (value) {
    for (var _iterator = (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* .createForOfIteratorHelperLoose */ .Ul)(cache.current), _step; !(_step = _iterator()).done;) {
      var ref = _step.value;
      if (ref == null) continue;
      if (typeof ref === 'function') ref(value);else ref.current = value;
    }
  }, [cache]);
}


//# sourceMappingURL=use-sync-refs.esm.js.map


/***/ }),

/***/ 35057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C5": function() { return /* binding */ focusElement; },
/* harmony export */   "GO": function() { return /* binding */ getFocusableElements; },
/* harmony export */   "TO": function() { return /* binding */ Focus; },
/* harmony export */   "fE": function() { return /* binding */ FocusResult; },
/* harmony export */   "jA": function() { return /* binding */ focusIn; },
/* harmony export */   "sP": function() { return /* binding */ isFocusableElement; },
/* harmony export */   "tJ": function() { return /* binding */ FocusableMode; }
/* harmony export */ });
/* harmony import */ var _match_esm_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(133);


//  - https://stackoverflow.com/a/30753870

var focusableSelector = /*#__PURE__*/['[contentEditable=true]', '[tabindex]', 'a[href]', 'area[href]', 'button:not([disabled])', 'iframe', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])'].map( false ? // TODO: Remove this once JSDOM fixes the issue where an element that is
// "hidden" can be the document.activeElement, because this is not possible
// in real browsers.
// TODO: Remove this once JSDOM fixes the issue where an element that is
0 : function (selector) {
  return selector + ":not([tabindex='-1'])";
}).join(',');
var Focus;

(function (Focus) {
  /** Focus the first non-disabled element */
  Focus[Focus["First"] = 1] = "First";
  /** Focus the previous non-disabled element */

  Focus[Focus["Previous"] = 2] = "Previous";
  /** Focus the next non-disabled element */

  Focus[Focus["Next"] = 4] = "Next";
  /** Focus the last non-disabled element */

  Focus[Focus["Last"] = 8] = "Last";
  /** Wrap tab around */

  Focus[Focus["WrapAround"] = 16] = "WrapAround";
  /** Prevent scrolling the focusable elements into view */

  Focus[Focus["NoScroll"] = 32] = "NoScroll";
})(Focus || (Focus = {}));

var FocusResult;

(function (FocusResult) {
  /** Something went wrong while trying to focus. */
  FocusResult[FocusResult["Error"] = 0] = "Error";
  /** When `Focus.WrapAround` is enabled, going from position `N` to `N+1` where `N` is the last index in the array, then we overflow. */

  FocusResult[FocusResult["Overflow"] = 1] = "Overflow";
  /** Focus was successful. */

  FocusResult[FocusResult["Success"] = 2] = "Success";
  /** When `Focus.WrapAround` is enabled, going from position `N` to `N-1` where `N` is the first index in the array, then we underflow. */

  FocusResult[FocusResult["Underflow"] = 3] = "Underflow";
})(FocusResult || (FocusResult = {}));

var Direction;

(function (Direction) {
  Direction[Direction["Previous"] = -1] = "Previous";
  Direction[Direction["Next"] = 1] = "Next";
})(Direction || (Direction = {}));

function getFocusableElements(container) {
  if (container === void 0) {
    container = document.body;
  }

  if (container == null) return [];
  return Array.from(container.querySelectorAll(focusableSelector));
}
var FocusableMode;

(function (FocusableMode) {
  /** The element itself must be focusable. */
  FocusableMode[FocusableMode["Strict"] = 0] = "Strict";
  /** The element should be inside of a focusable element. */

  FocusableMode[FocusableMode["Loose"] = 1] = "Loose";
})(FocusableMode || (FocusableMode = {}));

function isFocusableElement(element, mode) {
  var _match;

  if (mode === void 0) {
    mode = FocusableMode.Strict;
  }

  if (element === document.body) return false;
  return (0,_match_esm_js__WEBPACK_IMPORTED_MODULE_0__/* .match */ .E)(mode, (_match = {}, _match[FocusableMode.Strict] = function () {
    return element.matches(focusableSelector);
  }, _match[FocusableMode.Loose] = function () {
    var next = element;

    while (next !== null) {
      if (next.matches(focusableSelector)) return true;
      next = next.parentElement;
    }

    return false;
  }, _match));
}
function focusElement(element) {
  element == null ? void 0 : element.focus({
    preventScroll: true
  });
}
function focusIn(container, focus) {
  var elements = Array.isArray(container) ? container : getFocusableElements(container);
  var active = document.activeElement;

  var direction = function () {
    if (focus & (Focus.First | Focus.Next)) return Direction.Next;
    if (focus & (Focus.Previous | Focus.Last)) return Direction.Previous;
    throw new Error('Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last');
  }();

  var startIndex = function () {
    if (focus & Focus.First) return 0;
    if (focus & Focus.Previous) return Math.max(0, elements.indexOf(active)) - 1;
    if (focus & Focus.Next) return Math.max(0, elements.indexOf(active)) + 1;
    if (focus & Focus.Last) return elements.length - 1;
    throw new Error('Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last');
  }();

  var focusOptions = focus & Focus.NoScroll ? {
    preventScroll: true
  } : {};
  var offset = 0;
  var total = elements.length;
  var next = undefined;

  do {
    var _next;

    // Guard against infinite loops
    if (offset >= total || offset + total <= 0) return FocusResult.Error;
    var nextIdx = startIndex + offset;

    if (focus & Focus.WrapAround) {
      nextIdx = (nextIdx + total) % total;
    } else {
      if (nextIdx < 0) return FocusResult.Underflow;
      if (nextIdx >= total) return FocusResult.Overflow;
    }

    next = elements[nextIdx]; // Try the focus the next element, might not work if it is "hidden" to the user.

    (_next = next) == null ? void 0 : _next.focus(focusOptions); // Try the next one in line

    offset += direction;
  } while (next !== document.activeElement); // This is a little weird, but let me try and explain: There are a few scenario's
  // in chrome for example where a focused `<a>` tag does not get the default focus
  // styles and sometimes they do. This highly depends on whether you started by
  // clicking or by using your keyboard. When you programmatically add focus `anchor.focus()`
  // then the active element (document.activeElement) is this anchor, which is expected.
  // However in that case the default focus styles are not applied *unless* you
  // also add this tabindex.


  if (!next.hasAttribute('tabindex')) next.setAttribute('tabindex', '0');
  return FocusResult.Success;
}


//# sourceMappingURL=focus-management.esm.js.map


/***/ }),

/***/ 133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ match; }
/* harmony export */ });
function match(value, lookup) {
  if (value in lookup) {
    var returnValue = lookup[value];

    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    return typeof returnValue === 'function' ? returnValue.apply(void 0, args) : returnValue;
  }

  var error = new Error("Tried to handle \"" + value + "\" but there is no handler defined. Only defined handlers are: " + Object.keys(lookup).map(function (key) {
    return "\"" + key + "\"";
  }).join(', ') + ".");
  if (Error.captureStackTrace) Error.captureStackTrace(error, match);
  throw error;
}


//# sourceMappingURL=match.esm.js.map


/***/ }),

/***/ 58529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AN": function() { return /* binding */ Features; },
/* harmony export */   "l4": function() { return /* binding */ RenderStrategy; },
/* harmony export */   "sY": function() { return /* binding */ render; },
/* harmony export */   "yV": function() { return /* binding */ forwardRefWithAs; }
/* harmony export */ });
/* harmony import */ var _virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19642);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _match_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(133);




var Features;

(function (Features) {
  /** No features at all */
  Features[Features["None"] = 0] = "None";
  /**
   * When used, this will allow us to use one of the render strategies.
   *
   * **The render strategies are:**
   *    - **Unmount**   _(Will unmount the component.)_
   *    - **Hidden**    _(Will hide the component using the [hidden] attribute.)_
   */

  Features[Features["RenderStrategy"] = 1] = "RenderStrategy";
  /**
   * When used, this will allow the user of our component to be in control. This can be used when
   * you want to transition based on some state.
   */

  Features[Features["Static"] = 2] = "Static";
})(Features || (Features = {}));

var RenderStrategy;

(function (RenderStrategy) {
  RenderStrategy[RenderStrategy["Unmount"] = 0] = "Unmount";
  RenderStrategy[RenderStrategy["Hidden"] = 1] = "Hidden";
})(RenderStrategy || (RenderStrategy = {}));

function render(_ref) {
  var props = _ref.props,
      slot = _ref.slot,
      defaultTag = _ref.defaultTag,
      features = _ref.features,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible,
      name = _ref.name;
  // Visible always render
  if (visible) return _render(props, slot, defaultTag, name);
  var featureFlags = features != null ? features : Features.None;

  if (featureFlags & Features.Static) {
    var _props$static = props["static"],
        isStatic = _props$static === void 0 ? false : _props$static,
        rest = (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* .objectWithoutPropertiesLoose */ .gK)(props, ["static"]); // When the `static` prop is passed as `true`, then the user is in control, thus we don't care about anything else


    if (isStatic) return _render(rest, slot, defaultTag, name);
  }

  if (featureFlags & Features.RenderStrategy) {
    var _match;

    var _props$unmount = props.unmount,
        unmount = _props$unmount === void 0 ? true : _props$unmount,
        _rest = (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* .objectWithoutPropertiesLoose */ .gK)(props, ["unmount"]);

    var strategy = unmount ? RenderStrategy.Unmount : RenderStrategy.Hidden;
    return (0,_match_esm_js__WEBPACK_IMPORTED_MODULE_2__/* .match */ .E)(strategy, (_match = {}, _match[RenderStrategy.Unmount] = function () {
      return null;
    }, _match[RenderStrategy.Hidden] = function () {
      return _render((0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* ["extends"] */ .gY)({}, _rest, {
        hidden: true,
        style: {
          display: 'none'
        }
      }), slot, defaultTag, name);
    }, _match));
  } // No features enabled, just render


  return _render(props, slot, defaultTag, name);
}

function _render(props, slot, tag, name) {
  var _ref2;

  if (slot === void 0) {
    slot = {};
  }

  var _omit = omit(props, ['unmount', 'static']),
      _omit$as = _omit.as,
      Component = _omit$as === void 0 ? tag : _omit$as,
      children = _omit.children,
      _omit$refName = _omit.refName,
      refName = _omit$refName === void 0 ? 'ref' : _omit$refName,
      passThroughProps = (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* .objectWithoutPropertiesLoose */ .gK)(_omit, ["as", "children", "refName"]); // This allows us to use `<HeadlessUIComponent as={MyComponent} refName="innerRef" />`


  var refRelatedProps = props.ref !== undefined ? (_ref2 = {}, _ref2[refName] = props.ref, _ref2) : {};
  var resolvedChildren = typeof children === 'function' ? children(slot) : children; // Allow for className to be a function with the slot as the contents

  if (passThroughProps.className && typeof passThroughProps.className === 'function') {
    passThroughProps.className = passThroughProps.className(slot);
  }

  if (Component === react__WEBPACK_IMPORTED_MODULE_0__.Fragment) {
    if (Object.keys(passThroughProps).length > 0) {
      if (!(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(resolvedChildren) || Array.isArray(resolvedChildren) && resolvedChildren.length > 1) {
        throw new Error(['Passing props on "Fragment"!', '', "The current component <" + name + " /> is rendering a \"Fragment\".", "However we need to passthrough the following props:", Object.keys(passThroughProps).map(function (line) {
          return "  - " + line;
        }).join('\n'), '', 'You can apply a few solutions:', ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', 'Render a single element as the child so that we can forward the props onto that element.'].map(function (line) {
          return "  - " + line;
        }).join('\n')].join('\n'));
      }

      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(resolvedChildren, Object.assign({}, // Filter out undefined values so that they don't override the existing values
      mergeEventFunctions(compact(omit(passThroughProps, ['ref'])), resolvedChildren.props, ['onClick']), refRelatedProps));
    }
  }

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Component, Object.assign({}, omit(passThroughProps, ['ref']), Component !== react__WEBPACK_IMPORTED_MODULE_0__.Fragment && refRelatedProps), resolvedChildren);
}
/**
 * We can use this function for the following useCase:
 *
 * <Menu.Item> <button onClick={console.log} /> </Menu.Item>
 *
 * Our `Menu.Item` will have an internal `onClick`, if you passthrough an `onClick` to the actual
 * `Menu.Item` component we will call it correctly. However, when we have an `onClick` on the actual
 * first child, that one should _also_ be called (but before this implementation, it was just
 * overriding the `onClick`). But it is only when we *render* that we have access to the existing
 * props of this component.
 *
 * It's a bit hacky, and not that clean, but it is something internal and we have tests to rely on
 * so that we can refactor this later (if needed).
 */


function mergeEventFunctions(passThroughProps, existingProps, functionsToMerge) {
  var clone = Object.assign({}, passThroughProps);

  var _loop = function _loop() {
    var func = _step.value;

    if (passThroughProps[func] !== undefined && existingProps[func] !== undefined) {
      var _Object$assign;

      Object.assign(clone, (_Object$assign = {}, _Object$assign[func] = function (event) {
        // Props we control
        if (!event.defaultPrevented) passThroughProps[func](event); // Existing props on the component

        if (!event.defaultPrevented) existingProps[func](event);
      }, _Object$assign));
    }
  };

  for (var _iterator = (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* .createForOfIteratorHelperLoose */ .Ul)(functionsToMerge), _step; !(_step = _iterator()).done;) {
    _loop();
  }

  return clone;
}
/**
 * This is a hack, but basically we want to keep the full 'API' of the component, but we do want to
 * wrap it in a forwardRef so that we _can_ passthrough the ref
 */


function forwardRefWithAs(component) {
  var _component$displayNam;

  return Object.assign((0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(component), {
    displayName: (_component$displayNam = component.displayName) != null ? _component$displayNam : component.name
  });
}

function compact(object) {
  var clone = Object.assign({}, object);

  for (var key in clone) {
    if (clone[key] === undefined) delete clone[key];
  }

  return clone;
}

function omit(object, keysToOmit) {
  if (keysToOmit === void 0) {
    keysToOmit = [];
  }

  var clone = Object.assign({}, object);

  for (var _iterator2 = (0,_virtual_rollupPluginBabelHelpers_js__WEBPACK_IMPORTED_MODULE_1__/* .createForOfIteratorHelperLoose */ .Ul)(keysToOmit), _step2; !(_step2 = _iterator2()).done;) {
    var key = _step2.value;
    if (key in clone) delete clone[key];
  }

  return clone;
}


//# sourceMappingURL=render.esm.js.map


/***/ }),

/***/ 2694:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace",
      function () {
        return __webpack_require__(79520);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Fleet_Editor; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/img/tradly/new-editor.png
/* harmony default export */ var new_editor = ("/_next/static/media/new-editor.30e909d8d9ff07b18467be093b3123ec.png");
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./src/components/Tradly/Fleet/Editor.js




var Editor = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8 ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-between gap-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full h-auto max-w-[400px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "h2 mb-[70px] text-center md:text-start",
                            children: "No-code Editor"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-7",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start justify-start gap-5 w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " flex-none h-10 w-10 rounded-full bg-[#F4F5F7]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " grow space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[18px] leading-[32px] font-semibold",
                                                    children: "Manage Design System"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "ext-[14px] leading-[22px] font-normal w-[97%]",
                                                    children: [
                                                        " ",
                                                        "Apply the rules one global styling and applied everywhere. Color, Typography, Border, Shadow, etc. Customize your pages using block based"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start justify-start gap-5 w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " flex-none h-10 w-10 rounded-full bg-[#F4F5F7]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " grow space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[18px] leading-[32px] font-semibold",
                                                    children: "Pages & Blocks"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "ext-[14px] leading-[22px] font-normal w-[95%]",
                                                    children: "Customize the system designed pages using block based builder. Build more Dynamic pages using the Editor"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start justify-start gap-5 w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " flex-none h-10 w-10 rounded-full bg-[#F4F5F7]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " grow space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[18px] leading-[32px] font-semibold",
                                                    children: "CSS and Rules"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "ext-[14px] leading-[22px] font-normal w-[98%]",
                                                    children: "Customize each blocks using CSS Styles option with no-code. Apply rules for each block based on screen, user login level, order type, etc."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " w-auto h-auto ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: new_editor,
                        className: "w-full h-full object-container shadow-custom"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Fleet_Editor = (Editor);


/***/ }),

/***/ 26020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Fleet_SuperAdmin; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/img/tradly/listing-category.png
/* harmony default export */ var listing_category = ("/_next/static/media/listing-category.6d67db99bc43deea6ba5d631cca78238.png");
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./src/components/Tradly/Fleet/SuperAdmin.js




var SuperAdmin = function() {
    return(// component
    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-7xl mx-auto px-4 sm:px-6",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col md:flex-row items-center justify-between gap-8 md:gap-16 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full h-auto max-w-[400px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "h2 mb-[70px] text-center md:text-start",
                            children: "SuperAdmin Panel"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " flex flex-col gap-7 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start justify-start gap-5 w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " flex-none h-10 w-10 rounded-full bg-[#F4F5F7]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " grow space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[18px] leading-[32px] font-semibold",
                                                    children: "Manage CMS"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "ext-[14px] leading-[22px] font-normal w-[97%]",
                                                    children: "Control what you information you need when user signup, create multi vendor accounts, add listings."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start justify-start gap-5 w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " flex-none h-10 w-10 rounded-full bg-[#F4F5F7]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " grow space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[18px] leading-[32px] font-semibold",
                                                    children: "Run Business"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "ext-[14px] leading-[22px] font-normal w-[98%]",
                                                    children: "Quick Reports, Add Collections of Listings, Promotions, Discounts Coupons, Manage users/accounts/listings, Finance Operations."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start justify-start gap-5 w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " flex-none h-10 w-10 rounded-full bg-[#F4F5F7]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " grow space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[18px] leading-[32px] font-semibold",
                                                    children: "Setup your Project"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "ext-[14px] leading-[22px] font-normal w-[95%]",
                                                    children: "Customize emails, Payments, Shipments/Service, Revenue Model, Variants, etc"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " w-auto h-auto ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: listing_category,
                        className: "w-full max-w-3xl h-full object-container shadow-custom"
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var Fleet_SuperAdmin = (SuperAdmin);


/***/ }),

/***/ 31775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Fleet_Workspace; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/img/tradly/domains-hd.png
/* harmony default export */ var domains_hd = ("/_next/static/media/domains-hd.74840020ee5e257b13463f024858aeea.png");
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./src/components/Tradly/Fleet/Workspace.js




var Workspace = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8 ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-between gap-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " w-auto h-auto ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: domains_hd,
                        className: "w-full h-full object-container shadow-custom"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full h-auto max-w-[400px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "h2 mb-[70px] text-center md:text-start",
                            children: "Workspace"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-7 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start justify-start gap-5 w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " flex-none h-10 w-10 rounded-full bg-[#F4F5F7]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " grow space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[18px] leading-[32px] font-semibold",
                                                    children: "Manage Projects."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "ext-[14px] leading-[22px] font-normal w-[97%]",
                                                    children: "Switch between multiple Projects, Add Multiple Domains for a single project. Add custom domain."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start justify-start gap-5 w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " flex-none h-10 w-10 rounded-full bg-[#F4F5F7]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " grow space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[18px] leading-[32px] font-semibold",
                                                    children: "Layers. Integrations. Templates"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "ext-[14px] leading-[22px] font-normal w-[95%]",
                                                    children: "Add Blogs, System Pages to your platform from workspace. Manage Integrations. Change Templates"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start justify-start gap-5 w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " flex-none h-10 w-10 rounded-full bg-[#F4F5F7]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " grow space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[18px] leading-[32px] font-semibold",
                                                    children: "Expand Business"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "ext-[14px] leading-[22px] font-normal w-[98%]",
                                                    children: "Role Based Access Control(RBAC). Add/Remove Webhooks for Zapier."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Fleet_Workspace = (Workspace);


/***/ }),

/***/ 79520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constant/url.js
var url = __webpack_require__(99741);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/Modal.js
var Modal = __webpack_require__(44835);
// EXTERNAL MODULE: ./node_modules/react-typed/dist/react-typed.js
var react_typed = __webpack_require__(27788);
var react_typed_default = /*#__PURE__*/__webpack_require__.n(react_typed);
// EXTERNAL MODULE: ./constant/functions.js
var functions = __webpack_require__(60538);
// EXTERNAL MODULE: ./src/pages/api/api.js + 1 modules
var api = __webpack_require__(10107);
// EXTERNAL MODULE: ./constant/mixpnael.js
var mixpnael = __webpack_require__(70441);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/components/TradlyHome/MarketplaceHome.js











function MarketplaceHome() {
    var ref = (0,react.useState)(false), videoModalOpen = ref[0], setVideoModalOpen = ref[1];
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(null), userDetails = ref1[0], setUserDetails = ref1[1];
    var ref2 = (0,react.useState)(null), tenantDetails = ref2[0], setTenantDetails = ref2[1];
    // user Details and tenant details fetching
    (0,react.useEffect)(function() {
        if ((0,functions.getAuthKey)() !== undefined) {
            var auth_key = (0,functions.getAuthKey)();
            if (auth_key) {
                (0,api/* getUserDetails */.M_)(auth_key).then(function(res) {
                    if (res === null || res === void 0 ? void 0 : res.user) {
                        setUserDetails(res.user);
                    }
                });
                axios_default().get("/api/user_tenants_details", {
                    params: {
                        auth_key: (0,functions.getAuthKey)()
                    }
                }).then(function(res) {
                    setTenantDetails((0,functions.getSelectedTenantDetails)(res.data.data.tenants));
                }).catch(function(err) {
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    (err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.error) === null || ref2 === void 0 ? void 0 : ref2.message) && alert(err === null || err === void 0 ? void 0 : (ref3 = err.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.error) === null || ref5 === void 0 ? void 0 : ref5.message);
                });
            }
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none z-[-1]",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    width: "1360",
                    height: "578",
                    viewBox: "0 0 1360 578",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                x1: "50%",
                                y1: "0%",
                                x2: "50%",
                                y2: "100%",
                                id: "illustration-01",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        stopColor: "#FFF",
                                        offset: "0%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        stopColor: "#ccfbf1",
                                        offset: "77.402%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        stopColor: "#f0fdfa",
                                        offset: "100%"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            fill: "url(#illustration-01)",
                            fillRule: "evenodd",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "1232",
                                    cy: "128",
                                    r: "128"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "155",
                                    cy: "443",
                                    r: "64"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-6xl mx-auto px-4 sm:px-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pt-16 pb-12 md:pt-20 md:pb-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                            className: "text-center text-3xl font-normal leading-tighter tracking-wider",
                            children: [
                                "Launch a Marketplace Platform to",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_typed_default()), {
                                    className: "bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400",
                                    strings: [
                                        " TRADE",
                                        " GIVE AWAY",
                                        " SWAP",
                                        " RENT",
                                        " SUBSCRIBE",
                                        " DONATE", 
                                    ],
                                    typeSpeed: 50,
                                    backSpeed: 100,
                                    loop: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-center pt-12 pb-12 md:pb-16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                    className: "text-5xl md:text-6xl font-extrabold leading-tighter tracking-tighter mb-4 ",
                                    "data-aos": "zoom-y-out",
                                    children: [
                                        " ",
                                        "The Fastest way. Launch",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400",
                                            children: "your marketplace & Multi Vendor Platforms."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "max-w-3xl mx-auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-xl text-gray-600 mb-8",
                                            "data-aos": "zoom-y-out",
                                            "data-aos-delay": "150",
                                            children: "Whether you want to launch a marketplace platform for your small community or country, Tradly has modular infrastructure to suit almost everything."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "max-w-xs mx-auto sm:max-w-none sm:flex sm:justify-center",
                                            "data-aos": "zoom-y-out",
                                            "data-aos-delay": "300",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "btn text-white bg-blue-600 hover:bg-blue-700 w-full mb-4 sm:w-auto sm:mb-0",
                                                    href: "/signup",
                                                    onClick: function() {
                                                        var _obj;
                                                        (0,mixpnael/* MixpanelTracking */.n5)(mixpnael/* MixpanelEventName.homepage_template */.aK.homepage_template, (_obj = {}, (0,_define_property/* default */.Z)(_obj, mixpnael/* MixpanelPropertiesName.user_name */.Oe.user_name, userDetails === null || userDetails === void 0 ? void 0 : userDetails.name), (0,_define_property/* default */.Z)(_obj, mixpnael/* MixpanelPropertiesName.user_email */.Oe.user_email, userDetails === null || userDetails === void 0 ? void 0 : userDetails.email), (0,_define_property/* default */.Z)(_obj, mixpnael/* MixpanelPropertiesName.tenant_name */.Oe.tenant_name, tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.id), (0,_define_property/* default */.Z)(_obj, mixpnael/* MixpanelPropertiesName.homepage_sticky_buttons_property */.Oe.homepage_sticky_buttons_property, mixpnael/* MixpanelPropertiesValues.homepage_sticky_get_started */.JA.homepage_sticky_get_started), _obj));
                                                    },
                                                    children: "Get started - FREE!"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var TradlyHome_MarketplaceHome = (MarketplaceHome);

// EXTERNAL MODULE: ./src/partials/TradlyFooter.js + 4 modules
var TradlyFooter = __webpack_require__(48777);
// EXTERNAL MODULE: ./src/components/home/tradly-home/AnyDevices.jsx + 12 modules
var AnyDevices = __webpack_require__(81054);
// EXTERNAL MODULE: ./src/components/home/tradly-home/Integrations.jsx + 1 modules
var Integrations = __webpack_require__(96792);
// EXTERNAL MODULE: ./src/components/home/tradly-home/Studio.jsx + 1 modules
var Studio = __webpack_require__(93968);
// EXTERNAL MODULE: ./src/partials/Cta.js
var Cta = __webpack_require__(74756);
// EXTERNAL MODULE: ./src/components/Tradly/Fleet/SuperAdmin.js + 1 modules
var SuperAdmin = __webpack_require__(26020);
// EXTERNAL MODULE: ./src/components/Tradly/Fleet/Workspace.js + 1 modules
var Workspace = __webpack_require__(31775);
// EXTERNAL MODULE: ./src/components/Tradly/Fleet/Editor.js + 1 modules
var Editor = __webpack_require__(17626);
;// CONCATENATED MODULE: ./src/components/Tradly/marketplace/FeatureHome.js


var FeatureHome = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-[550px]max-w-7xl mx-auto px-4 sm:px-6 md:px-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: " h2 text-center mb-[70px] ",
                    children: "Why Tradly Platform"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-x-[30px] gap-y-10 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center justify-center gap-2 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " flex-none h-10 w-10 rounded-full bg-gray-300"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " grow space-y-2 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[16px] leading-[29px] font-semibold",
                                            children: "Deploy in days"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "ext-[16px] leading-[20px] font-normal w-[95%]",
                                            children: "Test your business idea, add your branding assets. Launch in a matter of days to test your ideas."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center justify-center gap-2 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " flex-none h-10 w-10 rounded-full bg-gray-300"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " grow space-y-2 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[16px] leading-[29px] font-semibold",
                                            children: "Focus on Growth"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "ext-[16px] leading-[20px] font-normal w-[95%]",
                                            children: "Tradly make it easier for your growth marketing team to have important marketing and analytical tools installed."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center justify-center gap-2 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " flex-none h-10 w-10 rounded-full bg-gray-300"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " grow space-y-2 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[16px] leading-[29px] font-semibold",
                                            children: "Less Risk"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "ext-[16px] leading-[20px] font-normal w-[95%]",
                                            children: "Without building a tech team to build something and unexpected situations. ​Experience first with our test apps and show to your users"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center justify-center gap-2 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " flex-none h-10 w-10 rounded-full bg-gray-300"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " grow space-y-2 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[16px] leading-[29px] font-semibold",
                                            children: "NEW FEATURES every month"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "ext-[16px] leading-[20px] font-normal w-[95%]",
                                            children: "All the fundamental market features are pre-built. And new stable features are getting released every month."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center justify-center gap-2 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " flex-none h-10 w-10 rounded-full bg-gray-300"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " grow space-y-2 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[16px] leading-[29px] font-semibold",
                                            children: "Simple to Advanced"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "ext-[16px] leading-[20px] font-normal w-[95%]",
                                            children: "Evolving toolkits. Simple pre-built templates. Blocks based feature to customize the page. Advanced No-code Editor to customize CSS. Webhooks, Open API, JS SDK for developers."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center justify-center gap-2 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " flex-none h-10 w-10 rounded-full bg-gray-300"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " grow space-y-2 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[16px] leading-[29px] font-semibold",
                                            children: "Social features pre-built"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "ext-[16px] leading-[20px] font-normal w-[95%]",
                                            children: "Make your platform sticky. Social media like features. Tags."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var marketplace_FeatureHome = (FeatureHome);

;// CONCATENATED MODULE: ./src/pages/marketplace/index.js












function Home() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "Free & Easy way to launch your marketplace Projects with no-code"
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Launch your marketplaces platforms without building from scratch. Free marketplace website templates, payment & marketing integrations, no-code marketplace builder, etc"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Simple & Easy way to launch your booking Portal & Website & App"
                    }, "og:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: " Marketplace Software - Free & Easy way to launch your marketplace platforms with no-code"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col min-h-screen overflow-hidden ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-grow",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TradlyHome_MarketplaceHome, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " max-w-6xl mx-auto pt-20 mb-20 space-y-40 overflow-hidden sm:mb-32 md:mb-40",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(marketplace_FeatureHome, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SuperAdmin/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Workspace/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Integrations/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AnyDevices/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Studio/* default */.Z, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cta/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TradlyFooter/* default */.Z, {})
                    ]
                })
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [25675,90585,48299,48777,589,49774,92888,40179], function() { return __webpack_exec__(2694); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);